import React, { memo } from 'react';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { Select } from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';

const OptionsCategorySelection = (props) => {
  const { categories, handleChange, category, disabled } = props;

  const menuCategories = categories.map((item) => (
    <MenuItem key={item.id} value={item.id}>
      {item.name}
    </MenuItem>
  ));

  const categoryChange = (value) => {
    const obj = categories.find((cat) => cat.id === value);
    return obj;
  };

  return (
    <MuiThemeProvider>
      <Select
        disabled={disabled}
        value={category.id}
        onChange={(event) => handleChange(categoryChange(event.target.value))}
      >
        {menuCategories}
      </Select>
    </MuiThemeProvider>
  );
};

OptionsCategorySelection.propTypes = {
  categories: PropTypes.arrayOf(PropTypes.shape(PropTypes.shape)).isRequired,
  handleChange: PropTypes.func.isRequired,
  category: PropTypes.shape(PropTypes.shape()),
  disabled: PropTypes.bool,
};

OptionsCategorySelection.defaultProps = {
  category: { id: 0 },
  disabled: false,
};

export default withTranslation('common')(memo(OptionsCategorySelection));
